var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('div',[_c('vs-tabs',{staticClass:"invoice-list"},[_c('vs-tab',{attrs:{"label":"Clinic"}},[_c('div',[_c('ClinicInvoiceList',{on:{"viewInvoiceDetailUpcoming":_vm.viewInvoiceDetailUpcoming}})],1)]),_c('vs-tab',{attrs:{"label":"Doctors"}},[_c('div',[_c('DoctorInvoiceList')],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }